export default {
  title: "EmPerA"
};
